import axios from '../utils/axios';

export const allLocations = async () =>
  await axios.get(`${process.env.REACT_APP_API}/locations`);

export const allCities = async () =>
  await axios.get(`${process.env.REACT_APP_API}/cities`);

export const citiesByState = async (state) =>
  await axios.get(`${process.env.REACT_APP_API}/cities/${state}`);

export const allCategories = async () =>
  await axios.get(`${process.env.REACT_APP_API}/admin/categories`);

export const getUsers = async () =>
  await axios.get(`${process.env.REACT_APP_API}/admin/users`);

export const deleteUser = async (userId) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/user/delete/${userId}`);

export const banUser = async (userId) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/user/ban/${userId}`);

export const unBanUser = async (userId) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/user/unban/${userId}`);

export const addLocation = async (location) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/add-location`, location);

export const deleteLocation = async (locationId) =>
  await axios.delete(`${process.env.REACT_APP_API}/admin/location/delete/${locationId}`);

export const getLocation = async (locationId) =>
  await axios.get(`${process.env.REACT_APP_API}/admin/location/edit/${locationId}`);

export const editLocation = async (locationId, location) =>
  await axios.put(`${process.env.REACT_APP_API}/admin/location/update/${locationId}`, location);

export const approveReport = async (reportId) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/approve-report/${reportId}`);

export const rejectReport = async (reportId) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/reject-report/${reportId}`);

export const productStatus = async () =>
  await axios.get(`${process.env.REACT_APP_API}/product-status`);

export const registerUser = async (userData) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/register-user`, userData);

export const changeUserPassword = async (userId, data) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/change-password/${userId}`, data);
